'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction from "./com.raquo.airstream.core.-Transaction.js";
import * as $j_com$002eraquo$002eairstream$002eownership$002e$002dDynamic$002dSubscription from "./com.raquo.airstream.ownership.-Dynamic-Subscription.js";
import * as $j_com$002eraquo$002eairstream$002eownership$002e$002dOne$002dTime$002dOwner from "./com.raquo.airstream.ownership.-One-Time-Owner.js";
import * as $j_com$002eraquo$002eew$002e$002dJs$002dArray$0024 from "./com.raquo.ew.-Js-Array$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $p_Lcom_raquo_airstream_ownership_DynamicOwner__removeSubscriptionNow__Lcom_raquo_airstream_ownership_DynamicSubscription__V($thiz, subscription) {
  var index = ($thiz.iz.indexOf(subscription) | 0);
  if ((index !== (-1))) {
    $thiz.iz.splice(index, 1);
    if ((!$thiz.f2.k())) {
      subscription.PN();
    }
  } else {
    throw $j_java$002elang$002e$002dObject.$ct_jl_Exception__T__(new $j_java$002elang$002e$002dObject.$c_jl_Exception(), "Can not remove DynamicSubscription from DynamicOwner: subscription not found. Did you already kill it?");
  }
}
export { $p_Lcom_raquo_airstream_ownership_DynamicOwner__removeSubscriptionNow__Lcom_raquo_airstream_ownership_DynamicSubscription__V as $p_Lcom_raquo_airstream_ownership_DynamicOwner__removeSubscriptionNow__Lcom_raquo_airstream_ownership_DynamicSubscription__V };
function $p_Lcom_raquo_airstream_ownership_DynamicOwner__removePendingSubscriptionsNow__V($thiz) {
  while ((($thiz.uW.length | 0) > 0)) {
    $p_Lcom_raquo_airstream_ownership_DynamicOwner__removeSubscriptionNow__Lcom_raquo_airstream_ownership_DynamicSubscription__V($thiz, $thiz.uW.shift());
  }
}
export { $p_Lcom_raquo_airstream_ownership_DynamicOwner__removePendingSubscriptionsNow__V as $p_Lcom_raquo_airstream_ownership_DynamicOwner__removePendingSubscriptionsNow__V };
/** @constructor */
function $c_Lcom_raquo_airstream_ownership_DynamicOwner(onAccessAfterKilled) {
  this.Eu = null;
  this.iz = null;
  this.lw = false;
  this.uW = null;
  this.f2 = null;
  this.lx = 0;
  this.Eu = onAccessAfterKilled;
  this.iz = $j_com$002eraquo$002eew$002e$002dJs$002dArray$0024.$m_Lcom_raquo_ew_JsArray$().db($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_com$002eraquo$002eairstream$002eownership$002e$002dDynamic$002dSubscription.$d_Lcom_raquo_airstream_ownership_DynamicSubscription.r().C)([])));
  this.lw = true;
  this.uW = $j_com$002eraquo$002eew$002e$002dJs$002dArray$0024.$m_Lcom_raquo_ew_JsArray$().db($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_com$002eraquo$002eairstream$002eownership$002e$002dDynamic$002dSubscription.$d_Lcom_raquo_airstream_ownership_DynamicSubscription.r().C)([])));
  this.f2 = $j_java$002elang$002e$002dObject.$m_s_None$();
  this.lx = 0;
}
export { $c_Lcom_raquo_airstream_ownership_DynamicOwner as $c_Lcom_raquo_airstream_ownership_DynamicOwner };
$p = $c_Lcom_raquo_airstream_ownership_DynamicOwner.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_ownership_DynamicOwner;
/** @constructor */
function $h_Lcom_raquo_airstream_ownership_DynamicOwner() {
}
export { $h_Lcom_raquo_airstream_ownership_DynamicOwner as $h_Lcom_raquo_airstream_ownership_DynamicOwner };
$h_Lcom_raquo_airstream_ownership_DynamicOwner.prototype = $p;
$p.NP = (function() {
  if ((!(!this.f2.k()))) {
    var this$4 = $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction.$m_Lcom_raquo_airstream_core_Transaction$onStart$();
    var f = (() => {
      var newOwner = new $j_com$002eraquo$002eairstream$002eownership$002e$002dOne$002dTime$002dOwner.$c_Lcom_raquo_airstream_ownership_OneTimeOwner(this.Eu);
      this.f2 = new $j_java$002elang$002e$002dObject.$c_s_Some(newOwner);
      this.lw = false;
      this.lx = 0;
      var i = 0;
      var originalNumSubs = (this.iz.length | 0);
      while ((i < originalNumSubs)) {
        var ix = ((i + this.lx) | 0);
        this.iz[ix].PM(newOwner);
        i = ((1 + i) | 0);
      }
      $p_Lcom_raquo_airstream_ownership_DynamicOwner__removePendingSubscriptionsNow__V(this);
      this.lw = true;
      this.lx = 0;
    });
    $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction.$m_Lcom_raquo_airstream_core_Transaction$onStart$();
    var when = true;
    if ((this$4.cG || (!when))) {
      f();
    } else {
      this$4.cG = true;
      try {
        f();
      } finally {
        this$4.cG = false;
        $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction.$p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V(this$4);
      }
    }
  } else {
    throw $j_java$002elang$002e$002dObject.$ct_jl_Exception__T__(new $j_java$002elang$002e$002dObject.$c_jl_Exception(), (("Can not activate " + this) + ": it is already active"));
  }
});
$p.Tp = (function() {
  if ((!this.f2.k())) {
    this.lw = false;
    var arr = this.iz;
    var i = 0;
    var len = (arr.length | 0);
    while ((i < len)) {
      arr[i].PN();
      i = ((1 + i) | 0);
    }
    $p_Lcom_raquo_airstream_ownership_DynamicOwner__removePendingSubscriptionsNow__V(this);
    var this$4 = this.f2;
    if ((!this$4.k())) {
      this$4.C().Px();
    }
    $p_Lcom_raquo_airstream_ownership_DynamicOwner__removePendingSubscriptionsNow__V(this);
    this.lw = true;
    this.f2 = $j_java$002elang$002e$002dObject.$m_s_None$();
  } else {
    throw $j_java$002elang$002e$002dObject.$ct_jl_Exception__T__(new $j_java$002elang$002e$002dObject.$c_jl_Exception(), "Can not deactivate DynamicOwner: it is not active");
  }
});
$p.S9 = (function(subscription, prepend) {
  if (prepend) {
    this.lx = ((1 + this.lx) | 0);
    this.iz.unshift(subscription);
  } else {
    this.iz.push(subscription);
  }
  var this$1 = this.f2;
  if ((!this$1.k())) {
    var x0 = this$1.C();
    subscription.PM(x0);
  }
});
$p.WY = (function(subscription) {
  if (this.lw) {
    $p_Lcom_raquo_airstream_ownership_DynamicOwner__removeSubscriptionNow__Lcom_raquo_airstream_ownership_DynamicSubscription__V(this, subscription);
  } else {
    this.uW.push(subscription);
  }
});
var $d_Lcom_raquo_airstream_ownership_DynamicOwner = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_ownership_DynamicOwner, "com.raquo.airstream.ownership.DynamicOwner", ({
  h1: 1
}));
export { $d_Lcom_raquo_airstream_ownership_DynamicOwner as $d_Lcom_raquo_airstream_ownership_DynamicOwner };
